import { useEffect } from "react";
import { socketService } from "../services/socket.service";
import { WebSocketEvent } from "../services/webSocketEvent";

export const useTablesSocket = (restaurantId: string, tableId: string) => {
  useEffect(() => {
    const initializeSocket = () => {
      if (!socketService.isConnected() && restaurantId && tableId) {
        socketService.connect(
          WebSocketEvent.TABLES_PUBLIC_SUBSCRIBE,
          restaurantId,
          tableId,
        );
      }
    };

    initializeSocket();

    return () => {
      socketService.disconnect();
    };
  }, [restaurantId, tableId]);

  return socketService;
};
